// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import SwitchPermissions from './switchPermissions/SwitchPermissions';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../../../../../common-utils/components/ui/accordion';
// Common
import getPermissionsByCategories from '@/common-utils/functions/getPermissionsByCategories';
// Lang
import { nsUser } from '@/app/i18n/namespaces';

/**
 *
 * @param props
 * @param props.userPermissions
 * @param props.isUpdate
 * @param props.setUserPermissions
 * @param props.showAllPermissions
 * @param props.allPermissionsToDisplay
 * @returns UserPermissions component
 */
function UserPermissions({ isUpdate, userPermissions, setUserPermissions = undefined, showAllPermissions = undefined, allPermissionsToDisplay = undefined }) {

    // Constants
    const allPermissionsToShow = isUpdate ? allPermissionsToDisplay : userPermissions;
    const categories = getPermissionsByCategories(allPermissionsToShow).map(perm => perm[0]);
    const permissionsByCategories = getPermissionsByCategories(allPermissionsToShow, true);

    // State
    const [accordionsOpened, setAccordionsOpened] = useState([]);

    // Hooks
    useEffect(() => {
        if (showAllPermissions && accordionsOpened.length !== categories.length) {
            setAccordionsOpened(categories);
        }
        if (!showAllPermissions && accordionsOpened.length !== 0) {
            setAccordionsOpened([]);
        }
    }, [showAllPermissions]);

    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
            {
                permissionsByCategories.map((column) => (
                    <div key={column.id} className='space-y-2'>
                        <Accordion key={'permissions-accordion'} type='multiple' value={accordionsOpened} onValueChange={setAccordionsOpened}>
                            {
                                column.col.map(([category, categoryPermissions]) => (
                                    <AccordionItem value={category} key={category}>
                                        <AccordionTrigger
                                            open={accordionsOpened.some(cat => cat === category)}
                                        >
                                            <Entity
                                                entity={`permissions.module.${category}`}
                                                namespace={nsUser}
                                                className={'font-bold text-base'}
                                            />
                                        </AccordionTrigger>
                                        <AccordionContent>
                                            <ul className={isUpdate ? 'list-none space-y-2' : 'list-disc pl-5 space-y-1'}>
                                                {
                                                    categoryPermissions.map((permissionName) => (
                                                        <li key={permissionName} >
                                                            {
                                                                isUpdate
                                                                    ? <SwitchPermissions
                                                                        permission={permissionName}
                                                                        userPermissions={userPermissions}
                                                                        setUserPermissions={setUserPermissions}
                                                                        isChecked={userPermissions.some(perm => perm === permissionName)}
                                                                    />
                                                                    : <Entity
                                                                        entity={`permissions.${permissionName}`}
                                                                        namespace={nsUser}
                                                                        className={'font-normal text-base'}
                                                                    />
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </AccordionContent>
                                    </AccordionItem>
                                ))
                            }
                        </Accordion>
                    </div>
                ))
            }
        </div>
    );
}
UserPermissions.propTypes = {
    userPermissions: PropTypes.array.isRequired,
    isUpdate: PropTypes.bool.isRequired,
    setUserPermissions: PropTypes.func,
    showAllPermissions: PropTypes.bool,
    allPermissionsToDisplay: PropTypes.array
};

export default UserPermissions;